export const dxFileUploaderMessages = {
    'pt-BR': {
      'dxFileUploader-selectFile': 'Selecionar arquivo',
      'dxFileUploader-dropFile': 'ou arraste um arquivo aqui',
      'dxFileUploader-invalidFileExtension': 'Extensão de arquivo inválida',
      'dxFileUploader-invalidMaxFileSize': 'Arquivo muito grande',
      'dxFileUploader-readyToUpload': 'Pronto para upload',
      'dxFileUploader-uploadedMessage': 'Upload concluído',
      'dxFileUploader-uploadFailedMessage': 'Falha no upload'
    },
    'en-US': {
      'dxFileUploader-selectFile': 'Select File',
      'dxFileUploader-dropFile': 'or drop a file here',
      'dxFileUploader-invalidFileExtension': 'Invalid file extension',
      'dxFileUploader-invalidMaxFileSize': 'File too large',
      'dxFileUploader-readyToUpload': 'Ready to upload',
      'dxFileUploader-uploadedMessage': 'Upload completed',
      'dxFileUploader-uploadFailedMessage': 'Upload failed'
    },
    'es-ES': {
      'dxFileUploader-selectFile': 'Seleccionar archivo',
      'dxFileUploader-dropFile': 'o arrastre un archivo aquí',
      'dxFileUploader-invalidFileExtension': 'Extensión de archivo no válida',
      'dxFileUploader-invalidMaxFileSize': 'Archivo demasiado grande',
      'dxFileUploader-readyToUpload': 'Listo para cargar',
      'dxFileUploader-uploadedMessage': 'Carga completada',
      'dxFileUploader-uploadFailedMessage': 'Error en la carga'
    }
};